export default __webpack_public_path__ + "static/media/propuestaMulti.c58fca25.svg";